var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "73fbb2ede8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 98 105.882812 L 277 105.882812 L 277 239 L 98 239 Z M 98 105.882812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f1adec6d7d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93.636719 105.882812 L 281.136719 105.882812 L 281.136719 244.632812 L 93.636719 244.632812 Z M 93.636719 105.882812 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#73fbb2ede8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#36a5ac",
    d: "M 276.652344 105.910156 L 276.652344 109.851562 C 257.632812 109.828125 247.566406 135.34375 247.566406 135.34375 L 192.414062 231.054688 C 190.242188 235.007812 188.90625 237.441406 187.703125 238.074219 C 186.496094 237.445312 185.164062 235.011719 182.992188 231.054688 L 127.832031 135.34375 C 127.832031 135.34375 117.648438 109.511719 98.398438 109.851562 C 98.28125 109.855469 98.171875 109.851562 98.0625 109.851562 L 98.0625 105.910156 C 98.097656 105.910156 98.132812 105.910156 98.171875 105.910156 L 132.003906 105.910156 C 138.726562 105.910156 144.519531 106.605469 148.691406 114.253906 L 187.703125 182.292969 L 226.710938 114.253906 C 230.882812 106.605469 236.675781 105.910156 243.398438 105.910156 Z M 276.652344 105.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f1adec6d7d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c11e1e",
    d: "M 139.292969 240.085938 L 139.292969 244.117188 L 93.636719 244.117188 L 93.636719 240.085938 L 96.207031 240.085938 C 101.246094 240.085938 105.324219 236 105.324219 230.964844 L 105.324219 153.679688 L 126.957031 187.554688 L 126.957031 230.964844 C 126.957031 236.003906 131.039062 240.085938 136.074219 240.085938 Z M 235.707031 240.273438 L 235.707031 244.304688 L 281.359375 244.304688 L 281.359375 240.273438 L 278.792969 240.273438 C 273.753906 240.273438 269.671875 236.1875 269.671875 231.152344 L 269.671875 153.871094 L 248.042969 187.746094 L 248.042969 231.15625 C 248.042969 236.195312 243.960938 240.277344 238.925781 240.277344 L 235.707031 240.277344 Z M 168 106.539062 L 187.355469 140.300781 L 206.714844 106.539062 C 206.832031 106.324219 206.953125 106.117188 207.070312 105.910156 L 167.640625 105.910156 C 167.757812 106.117188 167.878906 106.328125 168 106.539062 Z M 168 106.539062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMv);
export default __webpack_public_path__ + "static/media/mv.7a88e73775f013b679708db1d69cb6aa.svg";
export { ForwardRef as ReactComponent };